import React, {FC} from "react"

import {useTheme} from "@irati/ui/src/global/useTheme"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import {Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"

import {Img, TestimonialsContainer, TestimonialCard} from "./styled"

interface Props extends InjectIntl {}

const Testimonials: FC<Props> = ({formatMessage}) => {
  const theme = useTheme()

  return (
    <TestimonialsContainer justifyContent="space-between" gap={theme.spacing.three} marginBottom={2} padding={[2, 4]}>
      <TestimonialCard padding={[3, 4]}>
        <Flex direction="column" justifyContent="space-between">
          <Flex justifyContent="space-between" marginBottom={3}>
            <Flex alignItems="center">
              <Img medium src={formatMessage({id: "admin.components.integration.directorySync.hris.testimonials.item1.img"})} />
              <Flex direction="column" marginLeft={2}>
                <Body small weight="semibold">
                  <FormattedMessage id="admin.components.integration.directorySync.hris.testimonials.item1.title" />
                </Body>
                <Body small weight="semibold">
                  <FormattedMessage id="admin.components.integration.directorySync.hris.testimonials.item1.subTitle" />
                </Body>
              </Flex>
            </Flex>
            <Img height="60px" src={formatMessage({id: "admin.components.integration.directorySync.hris.testimonials.item1.img2"})} />
          </Flex>
          <Body maxWidth="100%" small color={theme.colors.primary2} weight="semibold" marginTop={2}>
            <FormattedMessage id="admin.components.integration.directorySync.hris.testimonials.item1.desc" />
          </Body>
        </Flex>
      </TestimonialCard>
      <TestimonialCard padding={[3, 4]}>
        <Flex direction="column" justifyContent="space-between">
          <Flex justifyContent="space-between" marginBottom={3}>
            <Flex alignItems="center">
              <Img medium src={formatMessage({id: "admin.components.integration.directorySync.hris.testimonials.item2.img"})} />
              <Flex direction="column" marginLeft={2}>
                <Body small weight="semibold">
                  <FormattedMessage id="admin.components.integration.directorySync.hris.testimonials.item2.title" />
                </Body>
                <Body small weight="semibold">
                  <FormattedMessage id="admin.components.integration.directorySync.hris.testimonials.item2.subTitle" />
                </Body>
              </Flex>
            </Flex>
            <Img height="35px" src={formatMessage({id: "admin.components.integration.directorySync.hris.testimonials.item2.img2"})} />
          </Flex>
          <Body maxWidth="100%" small color={theme.colors.primary2} weight="semibold">
            <FormattedMessage id="admin.components.integration.directorySync.hris.testimonials.item2.desc" />
          </Body>
        </Flex>
      </TestimonialCard>
    </TestimonialsContainer>
  )
}

export default injectIntl(Testimonials)
